// extracted by mini-css-extract-plugin
export var wordContainer = "_qo-0";